import React from 'react';
import Skeleton from 'react-loading-skeleton';

import './ListSkeleton.scss';

interface Props {
    count?: number;
}

const OutboxApprovalListSkeleton = ({ count = 1 }: Props): JSX.Element => (
    <div className="outbox-approval-list-skeleton">
        <div className="outbox-approval-list-list">
            {Array.from(Array(count)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className="outbox-approval-list-list-item" key={index}>
                    <Skeleton height={91} />
                </div>
            ))}
        </div>
    </div>
);

export default OutboxApprovalListSkeleton;
